import React from "react";
// import "./CourseHeroSection.css";
import { ArrowRight, Star, ArrowRightCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function CourseHeroSection() {

  const sessionData = sessionStorage.getItem("studentSession");
  const token = sessionData ? JSON.parse(sessionData)?.token : null;
  const redirectUrl = token ? "/dashboard" : "/login";


  return (
    <section className="course-hero-section-container">
      <div className="course-hero-section-overlay"></div>

      <div className="course-hero-section-content">
        <div className="course-hero-section-text">
          <h1 className="course-hero-section-title">
            UPSC Prelims & Mains Masterclass
          </h1>
          <p className="course-hero-section-tagline">
            Crack the toughest exams with expert guidance, comprehensive materials, and proven strategies.
          </p>

          <div className="course-hero-section-highlights">
            <div className="course-hero-section-highlight">
              <Star size={20} /> 500+ Successful Candidates
            </div>
            <div className="course-hero-section-highlight">
              <Star size={20} /> Expert Faculty
            </div>
            <div className="course-hero-section-highlight">
              <Star size={20} /> Updated Syllabus
            </div>
          </div>

          <Link
            to={redirectUrl}
            onClick={() => {
              sessionStorage.setItem("redirectFrom", window.location.pathname);
            }}
          >
            <button className="course-enroll-cta-button">
              Enroll Now <ArrowRightCircle size={24} />
            </button>
          </Link>
        </div>

        <div className="course-hero-section-image">
          <img
            src="https://images.unsplash.com/photo-1523240795612-9a054b0db644"
            alt="UPSC Course"
          />
        </div>
      </div>
    </section>
  );
}
